import {Injectable} from '@angular/core';
import {AuthService} from '../auth.service';
import {StudentModel} from '../../models/authentication/student.model';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {StringExtensionModel} from '../../models/extensions/string-extension.model';
import {StudentFilterModel} from '../../models/filters/student-filter.model';

@Injectable({
  providedIn: 'root'
})
export class AdminStudentService {

  constructor(private authSv: AuthService) {}


  fetchStudents(filter: StudentFilterModel): Observable<StudentModel []> {

    const url = '/admin/students' + StringExtensionModel.queryString(filter);

    return this.authSv.get(url.toString()).pipe(map((response) => {
      return StudentModel.generateModels(response.data);
    }));

  }

  /**
   * Deep copies a student (progress, skills, game data, book exam attempts) into a new student
   * in the given school. The copy has no group. Not idempotent and can be slow for large students.
   */
  copyStudent(studentId: string, firstName: string, middleName: string, lastName: string, schoolId: string): Observable<AdminStudentCopyResult> {

    const body = { firstName, middleName, lastName, schoolId };

    return this.authSv.post('/admin/students/' + studentId + '/copy', body).pipe(map((response) => {
      const result = new AdminStudentCopyResult();
      result.student = StudentModel.generateModel(response.data.student);
      result.copied = response.data.copied;
      return result;
    }));

  }

  fetchStudentById(studentId: string): Observable<StudentModel> {
    return this.authSv.get('/admin/students/' + studentId).pipe(map((studentReceived) => {
      const student = StudentModel.generateModel(studentReceived.data);
      return student;
    }));
  }

  updateStudentWithAdminPassword(studentInfo: StudentModel, password: string): Observable<StudentModel> {
    return this.authSv.patch('/admin/students', {infoStudent: studentInfo, password: password}).pipe(map((studentUpdated) => {
      const student = StudentModel.generateModel(studentUpdated.data);
      return student;
    }));
  }

  removeTokens(studentId: string): Observable<StudentModel> {

    let url = '/admin/students/' + studentId;
    url += '/removeTokens';

    return this.authSv.delete(url).pipe(map((response) => {

      const student = StudentModel.generateModel(response.data);
      return student;

    }));

  }

  fetchPlacementProgress(studentId: string): Observable<any> {
    return this.authSv.get('/admin/students/' + studentId + '/placementProgress').pipe(map((response) => {
      return response.data;
    }));
  }

}


export class AdminStudentCopyResult {

  student: StudentModel;
  copied: { [key: string]: number } = {};

}
